export enum TEXT_LINK_SIZES {
  SMALL = 'small',
  DEFAULT = 'default',
}

export enum TEXT_LINK_TYPES {
  ICON_RIGHT = 'icon-right',
  ICON_LEFT = 'icon-left',
  NO_ICON = 'no-icon',
}
